import React, { useEffect, useRef } from 'react'

import { useAppState } from '../appState'
import axios from '../axios'
import { baseURL, ENDPOINTS } from '../constants'
import {
  clearSuspendedBrandIds,
  setSuspendedBrandIds,
} from '../suspendedBrandsRegistry'

/**
 * Loads the current user's own active brand suspensions from the backend and mirrors them into
 * context plus `suspendedBrandsRegistry` for the brand-list filters. Mirrors `UserCjPidsSync`'s
 * shape (same auth-change lifecycle, same stale-response guard) — kept as a separate component since
 * suspension and CJ access are unrelated concepts with independent load states.
 */
const UserSuspendedBrandsSync = () => {
  const [{ auth, userId }, dispatch] = useAppState()
  const requestIdRef = useRef(0)

  useEffect(() => {
    if (!auth || userId == null || userId === '') {
      clearSuspendedBrandIds()
      dispatch({ type: 'RESET_SUSPENDED_BRANDS' })
      return
    }

    const id = ++requestIdRef.current
    let cancelled = false

    const run = async () => {
      clearSuspendedBrandIds()
      dispatch({ type: 'SET_SUSPENDED_BRANDS_LOADING' })
      try {
        const response = await axios.get(
          `${baseURL}${ENDPOINTS.suspendedBrandIds}`
        )
        if (cancelled || id !== requestIdRef.current) return

        const suspendedBrandIds = response?.data?.data?.suspendedBrandIds ?? []
        setSuspendedBrandIds(suspendedBrandIds)
        dispatch({ type: 'SET_SUSPENDED_BRANDS_SUCCESS', suspendedBrandIds })
      } catch {
        if (cancelled || id !== requestIdRef.current) return
        clearSuspendedBrandIds()
        dispatch({ type: 'SET_SUSPENDED_BRANDS_ERROR' })
      }
    }

    run()

    return () => {
      cancelled = true
    }
  }, [auth, userId, dispatch])

  return null
}

export default UserSuspendedBrandsSync
